(function () {
  'use strict';

  var menuLastFocusedElement = null;
  var cartToast = null;
  var cartToastTimer = null;
  var lastCartCount = null;
  var pendingCartAdditionUntil = 0;

  function isMobile() {
    return window.matchMedia('(max-width: 990px)').matches;
  }

  function getMobileMenuElements() {
    return {
      button: document.querySelector('[data-vmax-mobile-menu-toggle]'),
      drawer: document.querySelector('[data-vmax-mobile-drawer]'),
      close: document.querySelector('[data-vmax-mobile-menu-close]'),
      backdrop: document.querySelector('[data-vmax-mobile-menu-backdrop]')
    };
  }

  function getMobileCartCount() {
    var badge = document.querySelector('[data-vmax-mobile-cart-count]');
    if (!badge) return null;
    return Number.parseInt(badge.textContent, 10) || 0;
  }

  function setCartCountState() {
    document.querySelectorAll('[data-vmax-mobile-cart-count]').forEach(function (badge) {
      var count = Number.parseInt(badge.textContent, 10) || 0;
      badge.setAttribute('aria-label', (count === 0 ? theme.strings.mobileCartZero : count === 1 ? theme.strings.mobileCartOne : theme.strings.mobileCartOther).replace('__count__', count));
    });
  }

  function hideCartToast() {
    if (!cartToast || cartToast.hidden) return;

    cartToast.classList.remove('is-visible');
    window.setTimeout(function () {
      if (!cartToast.classList.contains('is-visible')) cartToast.hidden = true;
    }, 220);
  }

  function hideLegacyCartSuccessNotification() {
    document.querySelectorAll('[data-notify="container"].alert-success').forEach(function (notification) {
      notification.classList.add('vmax-mobile-cart-confirmation-replaced');
      notification.setAttribute('aria-hidden', 'true');
    });
  }

  function showCartToast() {
    if (!cartToast || !isMobile()) return;

    hideLegacyCartSuccessNotification();
    window.clearTimeout(cartToastTimer);
    cartToast.hidden = false;

    window.requestAnimationFrame(function () {
      cartToast.classList.add('is-visible');
    });

    cartToastTimer = window.setTimeout(hideCartToast, 4200);
  }

  function handleCartCountMutation() {
    var currentCount = getMobileCartCount();
    setCartCountState();

    if (currentCount === null) return;

    if (
      lastCartCount !== null &&
      currentCount > lastCartCount &&
      Date.now() <= pendingCartAdditionUntil
    ) {
      pendingCartAdditionUntil = 0;
      showCartToast();
    }

    lastCartCount = currentCount;
  }

  function rememberCartAdditionAttempt(event) {
    if (!isMobile() || !(event.target instanceof Element)) return;

    var button = event.target.closest(
      '.nm-addToCart.enable, .product-addToCart:not([disabled]), .qv-addToCart:not([disabled]), .vmax-mobile-card__footer button[type="submit"]'
    );
    if (!button || button.closest('[data-vmax-card-scanner]')) return;

    pendingCartAdditionUntil = Date.now() + 10000;
  }

  function isMenuOpen() {
    var menu = getMobileMenuElements();
    return Boolean(menu.drawer && !menu.drawer.hidden && menu.drawer.classList.contains('is-open'));
  }

  function setMobileMenuOpen(open, restoreFocus) {
    var menu = getMobileMenuElements();
    var wasOpen = isMenuOpen();

    if (!menu.drawer || !menu.button || !menu.backdrop) return;
    if (open && !isMobile()) return;

    if (open) {
      if (!wasOpen) menuLastFocusedElement = document.activeElement;

      menu.drawer.hidden = false;
      menu.backdrop.hidden = false;
      menu.drawer.classList.add('is-open');
      document.body.classList.add('vmax-mobile-menu-open');
      menu.button.setAttribute('aria-expanded', 'true');

      window.requestAnimationFrame(function () {
        menu.backdrop.classList.add('is-open');
      });

      window.setTimeout(function () {
        if (menu.close && isMenuOpen()) menu.close.focus();
      }, 0);

      return;
    }

    menu.drawer.classList.remove('is-open');
    menu.backdrop.classList.remove('is-open');
    menu.drawer.hidden = true;
    menu.backdrop.hidden = true;
    document.body.classList.remove('vmax-mobile-menu-open');
    menu.button.setAttribute('aria-expanded', 'false');

    if (wasOpen && restoreFocus !== false && menuLastFocusedElement && typeof menuLastFocusedElement.focus === 'function') {
      menuLastFocusedElement.focus();
    }

  }

  function closeMobileMenu(restoreFocus) {
    if (isMenuOpen()) setMobileMenuOpen(false, restoreFocus);
  }

  function keepFocusInsideMenu(event) {
    if (!isMenuOpen() || event.key !== 'Tab') return;

    var menu = getMobileMenuElements();
    if (!menu.drawer) return;

    var focusable = Array.prototype.filter.call(
      menu.drawer.querySelectorAll('button:not([disabled]), a[href], summary, [tabindex]:not([tabindex="-1"])'),
      function (element) {
        return !element.hidden && element.offsetParent !== null;
      }
    );

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function configureMobileMenu() {
    var menu = getMobileMenuElements();
    if (!menu.drawer || !menu.button || !menu.backdrop) return;

    menu.drawer.setAttribute('role', 'dialog');
    menu.drawer.setAttribute('aria-modal', 'true');
    menu.drawer.setAttribute('aria-labelledby', 'VmaxMobileDrawerTitle');
    menu.button.setAttribute('aria-controls', menu.drawer.id);

    if (!isMobile()) {
      setMobileMenuOpen(false, false);
      return;
    }

    if (!isMenuOpen()) {
      menu.drawer.hidden = true;
      menu.backdrop.hidden = true;
      menu.drawer.classList.remove('is-open');
      menu.backdrop.classList.remove('is-open');
      menu.button.setAttribute('aria-expanded', 'false');
    }
  }

  function initializeMenuInteractions() {
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      if (event.target.closest('[data-vmax-mobile-menu-toggle]')) {
        event.preventDefault();
        setMobileMenuOpen(!isMenuOpen());
        return;
      }

      if (event.target.closest('[data-vmax-mobile-menu-close], [data-vmax-mobile-menu-backdrop]')) {
        event.preventDefault();
        closeMobileMenu();
        return;
      }

      if (event.target.closest('[data-vmax-mobile-drawer] a')) {
        closeMobileMenu(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMobileMenu();
      keepFocusInsideMenu(event);
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) closeMobileMenu(false);
    }, { passive: true });

    document.addEventListener('shopify:section:load', configureMobileMenu);
  }

  function initialize() {
    cartToast = document.querySelector('[data-vmax-mobile-cart-toast]');
    lastCartCount = getMobileCartCount();

    initializeMenuInteractions();
    configureMobileMenu();

    document.addEventListener('click', rememberCartAdditionAttempt, true);

    if ('MutationObserver' in window) {
      document.querySelectorAll('[data-vmax-mobile-cart-count]').forEach(function (badge) {
        new MutationObserver(handleCartCountMutation).observe(badge, {
          childList: true,
          characterData: true,
          subtree: true
        });
      });
    }

    handleCartCountMutation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
